import React from "react";
import Navbar from "./Navbar/Navbar";
import TopBar from "./TopBar"
import { SocialMediaLink } from "../../utils/types/SocialMediaLink";

const Header:React.FC = () => {
    const links: SocialMediaLink[] = [
        { url: "https://www.facebook.com/lubomir.luhovy/", icon: "" }
    ];

    return (
        <header id ="header" className="site-header header-style-1">
            <TopBar phoneNumber={"+421 xxx xx xx xx"} address={"adresa"} email={"lubomir@luhovy.sk"} links={links}/>
            <Navbar />
        </header>
    )
};

export default Header;